import './contact.css';

import EmailIcon from '@mui/icons-material/Email';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';

const Contact = () => {
  return (
    <div>
      <div className="contact">
        <h2>Entre em contato conosco! </h2>
        <h3><i><WhatsAppIcon id='wppIcon' /> </i>21 98077 3683</h3>
      </div>
      <hr />
      <div className="mailContact">
        <h2>E-mail de contato <i><EmailIcon /></i></h2>
        <h4>casagourmetds@gmail.com</h4>
      </div>
      <div className="socialNetworkAba">
        <h2>Nos acompanhe nas redes sociais!</h2>
      </div>
      <div className="socialNetworkIcons">
        <div className="facebookIcon">
          <a href='https://www.facebook.com/Casa-Gourmet-Doces-e-Salgados-100498642753423'><FacebookIcon id='faceIcon' /></a>
        </div>
        <div className="instagramIcon">
          <a href='https://www.instagram.com/casagourmetds/'><InstagramIcon id='instaIcon' /></a>
        </div>
      </div>
    </div>
  )
}

export default Contact